<div class="mat-dialog-container-confirme border rounded-2">
    <div class="title-confirm d-flex justify-content-between align-items-center">
        <strong mat-dialog-title class="text-center fs-6 ms-4 w-100">{{title | translate}}</strong>
        <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
            (click)="onCancel()"></button>
    </div>

    <div class="fs-6 p-4 text-center">{{message | translate}}</div>

    <div class="m-4 d-flex justify-content-center">
        <button class="btn btn-light me-3 popup-secondary-button" mat-button (click)="onCancel()">{{'BUTTONS.CANCEL' | translate}}</button>
        <button class="btn btn-light me-3 popup-primary-button" mat-button color="warn"
            (click)="onConfirm()">{{'BUTTONS.CONFIRM' | translate}}</button>
    </div>
</div>